import React from 'react';
import styled from 'styled-components';
import { LoadingIndicator as TapeLoadingIndicator } from '@spotify-internal/creator-tape';

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
  height: 100%;
  justify-content: center;
`;

export function LoadingIndicator() {
  return (
    <Container>
      <TapeLoadingIndicator data-testid="loading-indicator" />
    </Container>
  );
}
